const STORAGE_KEY = 'card_payment_log'
const MAX_ENTRIES = 500

const safeStringify = (value) => {
    try {
        return JSON.stringify(value)
    } catch (e) {
        return String(value)
    }
}

const loadLog = () => {
    try {
        const raw = localStorage.getItem(STORAGE_KEY)
        if (!raw) return []
        const parsed = JSON.parse(raw)
        return Array.isArray(parsed) ? parsed : []
    } catch (e) {
        return []
    }
}

const saveLog = (entries) => {
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(entries))
    } catch (e) {
        // QuotaExceededError ili sl. — pokušaj prepoloviti i pisati ponovno
        try {
            const trimmed = entries.slice(-Math.floor(MAX_ENTRIES / 2))
            localStorage.setItem(STORAGE_KEY, JSON.stringify(trimmed))
        } catch (_) {
            // odustani tiho
        }
    }
}

export const logCard = (type, message, extra = {}) => {
    try {
        const entries = loadLog()
        entries.push({
            ts: new Date().toISOString(),
            type,
            message: typeof message === 'string' ? message : safeStringify(message),
            ...extra,
        })
        if (entries.length > MAX_ENTRIES) {
            entries.splice(0, entries.length - MAX_ENTRIES)
        }
        saveLog(entries)
    } catch (e) {
        // ne smije rušiti tok plaćanja
    }
    // Ako je tip kritičan, okini debounced slanje na backend (lazy import izbjegava cikličku ovisnost)
    try {
        // eslint-disable-next-line global-require
        const {notifyCriticalIfNeeded} = require('./logSender')
        notifyCriticalIfNeeded(type)
    } catch (_) {
        // ignore
    }
}

export const getCardLogs = () => loadLog()

export const getUnsentCardLogs = () => loadLog().filter((e) => !e.sent)

export const markCardLogsSent = (timestamps) => {
    if (!Array.isArray(timestamps) || timestamps.length === 0) return
    try {
        const set = new Set(timestamps)
        const entries = loadLog()
        let changed = false
        for (const e of entries) {
            if (!e.sent && set.has(e.ts)) {
                e.sent = true
                changed = true
            }
        }
        if (changed) saveLog(entries)
    } catch (_) {
        // ignore
    }
}

export const clearCardLogs = () => {
    try {
        localStorage.removeItem(STORAGE_KEY)
    } catch (e) {
        // ignore
    }
}

export const formatCardLogs = () => {
    const entries = loadLog()
    if (entries.length === 0) return '(prazno)'
    return entries
        .map((e) => {
            const { ts, type, message, ...rest } = e
            const restStr = Object.keys(rest).length ? ' ' + safeStringify(rest) : ''
            return `[${ts}] ${type}: ${message}${restStr}`
        })
        .join('\n')
}
